module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I was raised in the shadow of Fort Sumter. As a kid, my friends and I would ride bicycles to Fort Johnson and gaze out to the harbor onto Fort Sumter. We imagined that we were standing next to the beach battery that fired the first shot. We looked back to the city of Charleston, thinking about the crowds assembled at the Battery to watch the spectacle of war. At low tide, we would walk out from Fort Johnson to Fort Sumter collecting artifacts from the war left behind by the tides.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Visiting our local raconteur, Willie McLeod, at his plantation, he taught us that the proper name for the conflict was the War Between the States. He would often remark that calling it the Civil War implied that states were fighting for control of the country. He would remind us that we (the South) did not want control, we just wanted out!")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Though this is my tenth book, it is the first book I ever intended to write. I trust that I have been able to humanize the story of the beginning of the war. War is not romantic—war is no fairy tale. Unfortunately, it is the manner in which we seem to resolve our conflicts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am indebted to William Ellis McLeod and my grandfather, J. Frank Taylor, for my early education about “the war.” In college, I was privileged to take my courses (the American Civil War and the history of the South) from a Citadel professor, Captain Cousins, who would cross town on occasion to teach College of Charleston students about the stories of history he held so dear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am indebted to the staff at the Charleston Library Society and the South Carolina Room of the Charleston County Library. Their important collections serve writers and historians well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thank you to Laura All, Marshall Hudson and all the staff at The History Press for bringing this important story to print.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Thank you to my wife Karen and my children, Katey, Brooks and Taylor. They have been most tolerant of my fascination with history and writing. They have inspired me to reach out to tell the great stories of our young country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is my hope that this modest history will bring readers to want to know more about the fascinating people who played a role in this American drama. Their lives are worthy of study. Their stories deserve to be told.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0